import apiClient, { type PagedResponse } from '../client'
import type { CompanyResponse, CompanyPersonResponse, CompanyDocumentResponse, DocumentRequirementResponse } from '../models/response'
import type { PlantaResponse } from '../models/response/planta'
import type { CreatePlantaStep1Request } from '../models/request/planta'
import type { AddCompanyPersonRequest } from '../models/request/company'

const BASE_PATH = '/plantas'

export const plantasService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
  }): Promise<PagedResponse<CompanyResponse>> {
    return apiClient.get<PagedResponse<CompanyResponse>>(BASE_PATH, params)
  },

  async getById(id: string): Promise<PlantaResponse> {
    return apiClient.get<PlantaResponse>(`${BASE_PATH}/${id}`)
  },

  async getPending(): Promise<PlantaResponse> {
    return apiClient.get<PlantaResponse>(`${BASE_PATH}/pending`)
  },

  async createStep1(data: CreatePlantaStep1Request): Promise<PlantaResponse> {
    return apiClient.post<PlantaResponse, CreatePlantaStep1Request>(`${BASE_PATH}/step1`, data)
  },

  async addPerson(id: string, data: AddCompanyPersonRequest): Promise<CompanyPersonResponse> {
    return apiClient.post<CompanyPersonResponse, AddCompanyPersonRequest>(`${BASE_PATH}/${id}/step2/persons`, data)
  },

  async removePerson(id: string, companyPersonId: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}/step2/persons/${companyPersonId}`)
  },

  async uploadDocument(id: string, data: { companyBusinessId: string; documentTypeId: number; documentUuid?: string; fileName?: string; expiresAt?: string; notes?: string }): Promise<CompanyDocumentResponse> {
    return apiClient.post<CompanyDocumentResponse>(`${BASE_PATH}/${id}/step3/documents`, data)
  },

  async finalize(id: string): Promise<void> {
    return apiClient.post<void>(`${BASE_PATH}/${id}/finalize`)
  },

  async getDocumentRequirements(): Promise<DocumentRequirementResponse[]> {
    return apiClient.get<DocumentRequirementResponse[]>(`${BASE_PATH}/document-requirements`)
  },
}
